import type { CSSProperties } from 'react';

// phase-dashboard-polish-batch (Sharon 2026-07-19) — THE shared
// cell-with-side-icon structure for dashboard table cells.
//
// Design rule: the primary value of a column (date, sequence number) stays
// visually centered; auxiliary icons (hide/unhide eye, 🔒 lock, ↕ reorder)
// sit to the side WITHOUT shifting it. The guarantee is structural, not
// margin-nudged:
//
//   1. The cell keeps SYMMETRIC horizontal padding and text-align:center,
//      so the value's center is the cell's center by construction, at any
//      viewport width.
//   2. Icons are absolutely positioned inside the cell's left/right gutter,
//      vertically centered — their presence/absence can never reflow the
//      value or change the row height.
//
// Used by: SubmissionSubRow's Updated cell (eye), SubmissionSubRow's Seq
// cell (↕ left, 🔒 right) and SubmissionGroupRow's Seq cell (↕ left). A cell
// that could carry two icons puts one in each gutter (left + right), which
// is also why the Seq cell's lock and reorder occupy opposite sides.

/** Cell style for a value-centered cell that may carry side icons. `base`
 *  must already have symmetric horizontal padding + textAlign center. */
export function sideIconCell(base: CSSProperties): CSSProperties {
  return { ...base, position: 'relative' };
}

/** Absolutely positioned side-icon style: in the `side` gutter, vertically
 *  centered. Spread AFTER the icon's own styles. */
export function sideIcon(side: 'left' | 'right', offset: number = 4): CSSProperties {
  return {
    position: 'absolute',
    [side]: offset,
    top: '50%',
    transform: 'translateY(-50%)',
  };
}
